import { Tabs, Skeleton } from 'antd';
import { GetServerSidePropsContext } from 'next';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import SupportBannerPc from '@/components/SupportCommon/SupportBanner';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import Supports from '@/components/Search/Supports';
import { useGlobal } from '@/utils/useGlobal';
import { getSearchRes } from '@/service';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/support/search';

const { TabPane } = Tabs;
export default function Search({ keyword, lang, SEO }: any) {
    const { useState, useEffect, isMobile, useLang, useRouter } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const SupportBanner = isMobile ? SupportBannerH5 : SupportBannerPc;
    const [searchRes, setSearchRes] = useState({}); // 返回数据
    const [loading, setLoading] = useState(false); // loading
    const [count, setCount] = useState({
        product: 0,
        press: 0,
        support: 0,
        total: 0,
    }); // 各个tab的数量以及总数
    // 计算res各项total
    const calculateTotal = (searchRes: any) => {
        const res: any = { total: 0 };
        Object.keys(searchRes).forEach((key) => {
            res[key] = searchRes[key].length;
            res['total'] += res[key];
        });
        return res;
    };

    // 获取search接口res
    const handleSearch = async (keyWord: string) => {
        setLoading(true); // 打开loading
        try {
            const res: any = await getSearchRes({
                keyWord,
                searchScope: 'faq',
            });
            setLoading(false); // 关闭loading
            if (res.code === '0') {
                setSearchRes(res.data || {});
                setCount({ ...count, ...calculateTotal(res.data) });
                return;
            }
        } catch (e) {
            setLoading(false); // 关闭loading
        }
    };

    useEffect(() => {
        handleSearch(keyword).catch();
    }, [keyword]);

    const descMap: any = {
        river: t('searchkeyword.seo_desc_river_support'),
        delta: t('searchkeyword.seo_desc_delta_support'),
    };

    const titleMap: any = {
        river: t('searchkeyword.seo_title_river_support'),
        delta: t('searchkeyword.seo_title_delta_support'),
    };

    return (
        <PageLayout>
            <SEO title={titleMap[keyword] || titleMap.river} description={descMap[keyword] || descMap.river} />
            <SEOlinksA locale={locale} list={seoconfig[keyword]?.include} pathname={seoconfig[keyword]?.url} />
            <div className={`${css.supportSearch}`}>
                <SupportBanner searchValue={keyword} isShowInputOnly={true} subTitleShow={locale !== 'jp'} bgImages="/img/support.png" />
                <div className="searchRes">
                    <Tabs
                        defaultActiveKey="1"
                        tabBarExtraContent={
                            <span className="leftTotalRes font-family-regular">
                                {t('supportsearchkeyword.site_search_result', {
                                    number: count.total || 0,
                                })}
                            </span>
                        }
                    >
                        <TabPane tab={t('supportsearchkeyword.FAQ', { number: count.faq || 0 })} key="1">
                            {!loading ? <Supports faqs={searchRes.faq} /> : <Skeleton />}
                        </TabPane>
                    </Tabs>
                    {!!count.total && (
                        <p className="endRes font-family-medium">
                            {t('supportsearchkeyword.site_search_result_end_tab', {
                                number: count.total || 0,
                            })}
                        </p>
                    )}
                </div>
            </div>
        </PageLayout>
    );
}

export function getServerSideProps({ query }: GetServerSidePropsContext) {
    return {
        props: {
            keyword: query.keyword || '',
        },
    };
}
